import * as messages from "../../messages";
import { genericUpdate } from "../../utils/generic_update";
import { KeyedList } from "../../utils/List";

export interface AppTaskBroadcastsState {
  readonly tasks: KeyedList<messages.PatientTaskBroadcastDetails, "taskInstanceId">;
}

export class AppTaskBroadcastsState {
  static fromMessage = (message: messages.PatientTaskBroadcastList): AppTaskBroadcastsState => {
    let tasks = KeyedList.empty<messages.PatientTaskBroadcastDetails>()("taskInstanceId");

    message.taskBroadcasts.forEach((task) => {
      tasks = tasks.append(task);
    });

    return {
      tasks: tasks,
    };
  };

  static updateFromMessage = (
    appTasksState: AppTaskBroadcastsState,
    message: messages.PatientTaskBroadcastList
  ): AppTaskBroadcastsState => {
    return genericUpdate(appTasksState, AppTaskBroadcastsState.fromMessage(message));
  };
}
